import { client } from "./index";

export const makeGiwaHouseApi = async (payload) => {
  const response = await client.post("/api/v1/broads", payload);
  return response;
};

export const editGiwaHouseApi = async (giwaStyleId, payload) => {
  const response = await client.patch(
    `/api/v1/broads/style/${giwaStyleId}`,
    payload
  );
  return response;
};

export const getGiwaHouseApi = async (payload) => {
  const response = await client.get(`/api/v1/broads/${payload}`);
  return response;
};

export const getGiwaListApi = async (payload) => {
  const response = await client.get(
    `/api/v1/posts/all/${payload.broadId}?reverse=${payload.reverse}`
  );
  return response;
};

export const getGiwaDetailApi = async (payload) => {
  const response = await client.get(`/api/v1/posts/detail/${payload}`);
  return response;
};

export const addGiwaApi = async (payload) => {
  const response = await client.post(`/api/v1/posts`, payload);
  return response;
};

export const editGiwaReadApi = async (giwaId) => {
  const response = await client.patch(`/api/v1/posts/${giwaId}`);
  return response;
};
